import React, { useState } from 'react'
import useDeliveryPickupAxios, { useDeliveryPickupFormData } from '../utils/axios';
import { AutoSizer } from 'rsuite/esm/internals/Windowing';
import { useDispatch } from 'react-redux';
import { setDropOffOrdersCount } from '../features/DeliveryOrdersCountSlice';
import { setTransactionBySerialNumber } from '../features/DropOffSlice';

function useDropOffApi () {

    const DeliveryPortalAxios = useDeliveryPickupAxios();
    const DeliveryPortalAxios1 = useDeliveryPickupFormData();
    const DeliveryPortalClient = DeliveryPortalAxios;
    DeliveryPortalClient.defaults.timeout = 600000;
    const DeliveryPortalClient1 = DeliveryPortalAxios1;
    DeliveryPortalClient1.defaults.timeout = 600000;

    const [order, setOrder] = useState();
    const dispatch = useDispatch();

    const GetOrder = async (orderID) => {
        try {
            const response = await DeliveryPortalAxios.get("/DropOff/GetOrder", {
                params: { OrderID: orderID}
            })

            if(response && response.data && response.data.payload ) {
                setOrder(response.data.payload)
            }
        } catch (error) {
            console.error("Error to fetch order", error);
        }
    }

    const ScanQR = async (payload) => {
        const res = await DeliveryPortalAxios.post(
            `/DropOff/ScanQR`,
            payload
        );

        return res.data?.payload;
    }

    const GetDropOffCount = async () => {
        try{
            const response = await DeliveryPortalAxios.get("/DropOff/GetDropOffCount")

            if(response && response.data.payload) {
                dispatch(setDropOffOrdersCount(response.data.payload.count || 0))
            }
        } catch (error) {
            console.error(error);
        }

    }

    const GetTransactionBySerialNumber = async (serialNumber) => {
        try {
            const response = await DeliveryPortalAxios.get('/DropOff/GetTransactionBySerialNumber', {
                params: { SerialNumber: serialNumber}
            })

            if(response && response.data) {
                dispatch(setTransactionBySerialNumber(response.data))


                return true;
            }
        } catch (error) {
            console.error(error);
            return false;
        }
    }


  return {
    GetOrder,
    order,
    ScanQR,
    GetDropOffCount,
    GetTransactionBySerialNumber,

  }
}

export default useDropOffApi;
